import React, { useEffect, useMemo, useState } from 'react';
import { View } from 'react-native';
import Animated from 'react-native-reanimated';
import { rem } from 'design-system/values';
import Spacer from 'design-system/Spacer';
import { useMarginBottom } from 'hooks/useMarginBottom';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
import NoLearnContent from './NoLearnContent';
import LearnVideosSection from './LearnVideosSection';
import LearnWalkthroughCard from './LearnWalkthroughCard';
import LearnArticlesSection from './LearnArticlesSection';
import { isWeb } from '../../../../constants';
const LearnCategoryScreen = ({ walkThroughData, walkThroughHandler, scrollViewRef, categoryScrollHandler, learnContent, showWalkthrough, initialTitle, }) => {
    const [showScreen, setShowScreen] = useState(initialTitle ? initialTitle === 'emma' || initialTitle === 'invest' : true);
    useEffect(() => {
        if (!showScreen) {
            const timeout = setTimeout(() => {
                setShowScreen(true);
            }, 200);
            return () => {
                clearTimeout(timeout);
            };
        }
        return () => { };
    }, [showScreen]);
    const { paddingHorizontal } = useAppFrameDimensions(isWeb);
    const paddingBottom = useMarginBottom('paddingBottom');
    const paddingHorizontalStyle = useMemo(() => ({
        paddingHorizontal: paddingHorizontal + rem(16),
    }), [paddingHorizontal]);
    const learnVideos = learnContent?.videos || [];
    const learnArticles = learnContent?.articles || [];
    return (<Animated.ScrollView ref={scrollViewRef} scrollEventThrottle={16} keyboardDismissMode="on-drag" onScroll={categoryScrollHandler} showsVerticalScrollIndicator={false} keyboardShouldPersistTaps="handled" contentContainerStyle={paddingBottom}>
      {showScreen ? (<>
          {!isWeb &&
                walkThroughData &&
                walkThroughHandler &&
                showWalkthrough ? (<LearnWalkthroughCard data={walkThroughData} onPress={walkThroughHandler} contentContainerStyle={paddingHorizontalStyle}/>) : null}
          {learnVideos.length === 0 &&
                learnArticles.length === 0 &&
                !showWalkthrough ? (<NoLearnContent />) : (<View>
              <LearnVideosSection learnVideos={learnVideos} contentContainerStyle={paddingHorizontalStyle}/>
              <LearnArticlesSection learnArticles={learnArticles} contentContainerStyle={paddingHorizontalStyle}/>
              {isWeb ? <Spacer h={24}/> : null}
            </View>)}
        </>) : null}
    </Animated.ScrollView>);
};
export default LearnCategoryScreen;
